import italian from '@amcharts/amcharts5/locales/it_IT';

// Stock controls are not included in amCharts' base Italian locale.
export const italianStock = {
  "Period": "Periodo",
  "Deviation": "Deviazione",
  "Upper": "Superiore",
  "Average": "Media",
  "Lower": "Inferiore",
  "Field": "Campo",
  "Type": "Tipo",
  "Reset to default": "Ripristina predefiniti",
  "Save": "Salva",
  "Cancel": "Annulla",
  "Close": "Chiudi",
  "Minimize": "Riduci",
  "Confirm": "Conferma",
  "Apply": "Applica",
  "Search": "Cerca",
  "Select": "Seleziona",
  "Settings": "Impostazioni",
  "Indicators": "Indicatori",
  "Comparison": "Confronto",
  "Period selector": "Selettore periodo",
  "Date Range": "Intervallo date",
  "From date": "Data iniziale",
  "To date": "Data finale",
  "Reset": "Ripristina",
  "Undo drawing": "Annulla disegno",
  "Redo drawing": "Ripristina disegno",
  "Bollinger Bands": "Bollinger Bands",
  "Moving Average": "Moving Average",
  "Moving Average Type": "Tipo di media mobile",
  "Moving Average Cross": "Moving Average Cross",
  "Moving Average Deviation": "Moving Average Deviation",
  "Moving Average Envelope": "Moving Average Envelope",
  "Standard Deviation": "Standard Deviation",
  "Typical Price": "Typical Price",
  "Median Price": "Median Price",
  "Relative Strength Index": "Relative Strength Index",
  "Average True Range": "Average True Range",
  "Accumulation/Distribution": "Accumulation/Distribution",
  "Accum/Dist": "Accum/Dist",
  "Accumulative Swing Index": "Accumulative Swing Index",
  "Acceleration Bands": "Acceleration Bands",
  "Awesome Oscillator": "Awesome Oscillator",
  "Chaikin Money Flow": "Chaikin Money Flow",
  "Chaikin Oscillator": "Chaikin Oscillator",
  "Commodity Channel Index": "Commodity Channel Index",
  "Disparity Index": "Disparity Index",
  "Price Volume Trend": "Price Volume Trend",
  "On Balance Volume": "On Balance Volume",
  "Stochastic Momentum Index": "Stochastic Momentum Index",
  "Stochastic Oscillator": "Stochastic Oscillator",
  "Volume-Weighted Average Price": "Volume-Weighted Average Price",
  "Volume Profile": "Volume Profile",
  "Bull Bear Power": "Bull Bear Power",
  "Color": "Colore",
  "Fill": "Riempimento",
  "Fill color": "Colore riempimento",
  "Fills": "Riempimenti",
  "Line": "Linea",
  "Line color": "Colore linea",
  "Line style": "Stile linea",
  "Line thickness": "Spessore linea",
  "Text": "Testo",
  "Text color": "Colore testo",
  "Bold": "Grassetto",
  "Italic": "Corsivo",
  "Label font family": "Carattere etichetta",
  "Label font size": "Dimensione etichetta",
  "Offset": "Scostamento",
  "Shift": "Spostamento",
  "Shift type": "Tipo di spostamento",
  "Multiplier": "Moltiplicatore",
  "Factor": "Fattore",
  "Fast period": "Periodo veloce",
  "Slow period": "Periodo lento",
  "Fast MA period": "Periodo media mobile veloce",
  "Slow MA period": "Periodo media mobile lenta",
  "Signal period": "Periodo segnale",
  "Signal": "Segnale",
  "Signal color": "Colore segnale",
  "SMA period": "Periodo SMA",
  "EMA period": "Periodo EMA",
  "K period": "Periodo K",
  "D period": "Periodo D",
  "Overbought": "Ipercomprato",
  "Oversold": "Ipervenduto",
  "Positive color": "Colore positivo",
  "Negative color": "Colore negativo",
  "Up volume": "Volume in rialzo",
  "Down volume": "Volume in ribasso",
  "Use Volume": "Usa volume",
  "Value Area": "Area di valore",
  "Width %": "Larghezza %",
  "Depth": "Profondità",
  "Count": "Conteggio",
  "Acceleration": "Accelerazione",
  "Limit move value": "Valore limite del movimento",
  "Median": "Mediana",
  "Top": "Superiore",
  "Bottom": "Inferiore",
  "Increasing": "In aumento",
  "Decreasing": "In diminuzione",
  "Increase": "Aumento",
  "Decrease": "Diminuzione",
  "Draw": "Disegna",
  "Drawing tool": "Strumento di disegno",
  "Eraser": "Gomma",
  "Clear": "Cancella",
  "Clear all drawings": "Cancella tutti i disegni",
  "Selection": "Selezione",
  "Arrows &amp; Icons": "Frecce e icone",
  "Drawings &amp; Indicators": "Disegni e indicatori",
  "Auto-save": "Salvataggio automatico",
  "Auto-save drawings and indicators": "Salva automaticamente disegni e indicatori",
  "Save drawings &amp; indicators": "Salva disegni e indicatori",
  "Save drawings and indicators": "Salva disegni e indicatori",
  "Restore saved data": "Ripristina dati salvati",
  "Saves drawings/indicators to browser local storage": "Salva disegni e indicatori nella memoria locale del browser",
  "Restores saved data from browser local storage": "Ripristina i dati dalla memoria locale del browser",
  "Clears saved data from browser local storage": "Cancella i dati salvati nella memoria locale del browser",
  "Snap icon to data": "Aggancia icona ai dati",
  "Show line extension": "Mostra estensione linea",
  "X-axis fills": "Riempimenti asse X",
  "Y-axis scale": "Scala asse Y",
  "Logarithmic": "Logaritmica",
  "Regular": "Normale",
  "Change percent": "Variazione percentuale",
  "Candles": "Candele",
  "Hollow Candles": "Candele vuote",
  "Sticks": "Barre",
  "Click to toggle": "Clicca per attivare o disattivare",
  "Scroll to increment": "Scorri per incrementare",
  "Search results are limited to %1.": "I risultati della ricerca sono limitati a %1.",
  "Hour": "Ora",
  "Minute": "Minuto",
  "Month": "Mese",
  "Year": "Anno",
  "day": "giorno",
  "hour": "ora",
  "hours": "ore",
  "minute": "minuto",
  "minutes": "minuti",
  "month": "mese",
  "week": "settimana",
  "year": "anno",
  "bars": "barre",
  "to": "a",
  "number of rows": "numero di righe",
  "ticks per row": "tick per riga",
  "percent": "percentuale",
  "points": "punti",
  "Points/Percent": "Punti/Percentuale",
  "Wk": "Sett.",
  "YTD": "Da inizio anno",
  "close": "chiusura",
  "open": "apertura",
  "high": "massimo",
  "low": "minimo",
  "simple": "semplice",
  "weighted": "ponderata",
  "exponential": "esponenziale",
  "smoothed": "smussata",
  "period": "periodo",
  "deviation": "deviazione",
  "offset": "scostamento",
  "fast": "veloce",
  "slow": "lento",
  "signal": "segnale",
  "field": "campo",
  "type": "tipo",
  "multiplier": "moltiplicatore"
};
// Drawing controls retain English labels across application languages.
const drawingEnglish = Object.fromEntries(["Draw","Drawing tool","Line","Average","Arrows &amp; Icons","Snap icon to data","Line color","Line thickness","Line style","Fill","Fill color","Text","Text color","Label font size","Bold","Italic","Label font family","Show line extension","Select","Selection","Eraser","Clear","Clear all drawings","Undo drawing","Redo drawing"].map(key => [key, key]));
export const chartLocale = language => language?.startsWith('it') ? { ...italian, ...italianStock, ...drawingEnglish } : {};
export const chartText = (text, language) => language?.startsWith('it') ? (drawingEnglish[text] || italianStock[text] || text) : text;
